<template>
    <div class="col-12" :class="{'col-md-6' : view === 'RE'}" :id="folder">
        <div class="form-group">
            <label v-if="label">{{$t(label)}}</label>
            <vue-dropzone :id="code"
                          :ref="code"
                          :options="dropZoneOptions"
                          @vdropzone-mounted="onDropZoneMounted"
                          @vdropzone-upload-progress="onDropZoneProgress"
                          @vdropzone-success="onDropZoneSuccess"
                          @vdropzone-error="onDropZoneError"
                          @vdropzone-removed-file="onDropZoneRemove"
                          @vdropzone-file-added="onDropZoneFileAdded"
                          @vdropzone-files-added="onDropZoneFilesAdded"
                          @vdropzone-processing="(file) => processingEvent(file, '')"
                          :class="{'invalid' : hasError, 'has-file': files.length > 0}">
            </vue-dropzone>
        </div>
    </div>
</template>

<script>
    import {BASE_API_UPLOAD} from '@/axios';
    import Cookie from 'js-cookie';
    import $ from 'jquery';
    import {clickImage} from '@/shared/utils';
    import {mapState} from "vuex";
    import {getArchiveModeDetailsByVersion} from "@/shared/archive-mode-utils";

    export default {
        // props: ['code', 'label', 'view', 'folder', 'maxFiles', 'data'],
        props: {
            code: String,
            label: String,
            folder: {
                type: String,
                default: ''
            },
            data: Array,
            view: {
                type: String,
                default: 'RE'
            },
            maxFiles: {
                type: Number,
                default: 100
            },
            hasError: {
                type: Boolean,
                default: false
            },
            url: {
                type: String,
                default: 'upload/save/new',
            },
            acceptedFiles: {
                type: String,
                default: "image/*,application/pdf",
            },
            callBackData: {
                type: Boolean,
                default: false
            },
            date: {
                type: String,
                default: ''
            },
            columnSettings: {
                type: String,
            }

        },
        computed: {
          ...mapState(['archiveModeVersion'])
        },
        data() {
            const vm = this;
            return {
                dropZoneOptions: {
                    url: BASE_API_UPLOAD + this.$props.url,
                    maxFiles: this.maxFiles,
                    acceptedFiles: this.$props.acceptedFiles,
                    addRemoveLinks: true,
                    uploadMultiple: true,
                    paramName: function () {
                      return "file";
                    },
                    headers: { 
                        'Authorization': `Bearer ` + Cookie.get('x_token_' + process.env.VUE_APP_NAME),
                        "startDate": this.$props.date,
                        "columnSettings": this.$props.columnSettings,
                        "subFolderName": vm.folder
                    },
                    dictDefaultMessage: this.$t('dropzone.defaultMessage'),
                    dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
                    dictCancelUpload: this.$t('dropzone.cancelUpload'),
                    dictCancelUploadConfirmation: this.$t('dropzone.cancelUploadConfirmation'),
                    dictRemoveFile: this.$t('dropzone.removeFile'),
                    dictRemoveFileConfirmation:  this.$t('dropzone.removeFileConfirmation')
                },
                files: [],
                files_added: []
            }
        },
        mounted() {
          this.updateDropzoneURL();
        },
        methods: {
            initFiles() {
                const dropZone = this.$refs[this.code];
                if (this.data && this.data.length > 0 && dropZone) {
                    this.data.forEach((file, index) => {
                        if (file && file.id && file.id > 0 && file.filePath && file.filePath.length > 0) {
                            if (!this.files_added.includes(file.id)) {
                                dropZone.manuallyAddFile(file, file.filePath);
                                this.files.push(file);
                                this.files_added.push(file.id);
                                var drop_zone_divs = $("#" + this.code + " > div.dz-preview .dz-image > img");
                                drop_zone_divs[index].setAttribute("url", file.filePath);
                            }
                        }
                    });
                    clickImage("#" + this.code);
                }
            },
            onDropZoneProgress(file, progress, bytesSent) {
                this.processing = true;
                console.log('dz-progress:' + progress + ':' + bytesSent);
            },
            onDropZoneSuccess(file, response) {
                if (this.callBackData) {
                    this.$emit('change', response.data);
                    return;
                }

                this.processing = false;
                if (!this.files) {
                    this.files = [];
                }
                if (response) {
                    if (response.data && response.data.id && response.data.id > 0) {
                        if (!this.hasFileId(response.data.id)) {
                            this.files.push(response.data);
                            this.files_added.push(response.data.id);
                        }
                    } else if (response.length > 0) {
                        response.forEach((file) => {
                            if (!this.hasFileId(file.id)) {
                                this.files.push(file);
                                this.files_added.push(file.id);
                            }
                        });
                    }
                }
                this.$emit('change', this.files);
                console.log('dz-success');
                console.log(response);
            },
            hasFileId(fileId) {
                let hasFile = false;
                if (this.files && this.files.length > 0) {
                    this.files.forEach((file) => {
                        if (file.id === fileId) {
                            hasFile = true;
                        }
                    });
                }
                return hasFile;
            },
            onDropZoneError() {
                this.processing = false;
                console.log('dz-error');
            },
            onDropZoneRemove(file/*, error, xhr*/) {
                if (this.files && this.files.length > 0) {
                    let fileIndex = null;
                    let hasFile = false;
                    for (let i = 0; i < this.files.length; i++) {
                        if (this.files[i].id === file.id) {
                            fileIndex = i;
                            hasFile = true;
                        }
                    }
                    if (hasFile) {
                        this.files.splice(fileIndex, 1);
                    }
                }
                this.$emit('change', this.files);
                console.log('dz-remove');
            },
            onDropZoneMounted() {
                console.log('dz-mounted');
                this.initFiles();
            },
            onDropZoneFileAdded(file) {
                // console.log('file_added_url', file.filePath);
                this.onFileAdded(file);
            },
            onDropZoneFilesAdded(files) {
                // console.log('files_added', files);
                if (files && files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        this.onFileAdded(files[i]);
                    }
                }
            },
            onFileAdded(file) {
                if (file && file.type && file.type.length > 0 && file.type.startsWith('image')) {
                    file.previewElement.addEventListener("click", () => {
                        // this.$eventBus.$emit('showDropZoneImagePreview', {
                        //     url: (file.filePath && file.filePath.length > 0 ? file.filePath : file.dataURL)
                        // });
                        // console.log('file_details_clicked', file.filePath);
                    });
                }
            },
            processingEvent (file, album) {
                let dropZone = this.$refs[this.code];
                const vm = this;
                dropZone.setOption('headers', {
                        'Authorization': `Bearer ` + Cookie.get('x_token_' + process.env.VUE_APP_NAME),
                        "startDate": this.$props.date,
                        "columnSettings": this.$props.columnSettings,
                        "subFolderName": vm.folder
                    }
                );
                console.log(album);
                console.log(file)
            },
            updateDropzoneURL() {
              this.dropZoneOptions.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + this.$props.url;
              if(this.$refs[this.$props.code] && this.$refs[this.$props.code].dropzone && this.$refs[this.$props.code].dropzone.options) {
                this.$refs[this.$props.code].dropzone.options.url = (this.archiveModeVersion ? getArchiveModeDetailsByVersion(this.archiveModeVersion).url : BASE_API_UPLOAD) + this.$props.url
              }
            }
        },
        watch: {
            // Watch for value change
            data: {
                immediate: true,
                // handle the changed value
                handler(val) {
                    console.log(val);
                    this.initFiles();
                }
            },
            columnSettings: {
                immediate: true,
                handler(val) {
                    console.log(val);
                }
            },
        }
    }
</script>

<style>

</style>
